import styled from '@emotion/styled'
import { css } from '@emotion/css'

export const CheckboxGroupDefaultClass = css``
